import { Card, Col } from "antd";
import { useGetInsightQuery } from "../../slices/strategyApiSlice";

const InsightsCard = ({ strategyId }) => {
  const { data: insight } = useGetInsightQuery(strategyId, {
    skip: !strategyId,
  });

  return (
    <Col md={24} xs={24}>
      <Card title="💡 Insights">
        <div style={{ lineHeight: "32px" }}>
          <div style={{ color: "#d09d4c" }}>
            ● Highest win rate on {insight?.highestWinDay} (
            {insight?.winRate}%)
          </div>

          <div style={{ color: "#ffffff" }}>
            ● {insight?.lossAfter3Win} losses after 3 consecutive wins
          </div>

          <div style={{ color: "#d09d4c" }}>
            ● Best performance between {insight?.bestTime}
          </div>
        </div>
      </Card>
    </Col>
  );
};

export default InsightsCard;